const initialvalues = {
  otpdetails: false,
  mediumDetails: [],
  languageDetails: [],
  courseDetails: [],
  castesListDetails: [],
  subcastesListDetails: [],
  occupationListDetails: [],
  mothertongueListDetails: [],
  stateListDetails: [],
  districtListDetails: [],
  mandalListDetails: [],
  pmssMandalListDetails: [],
  villageListDetails: [],
  secreateListDetails: [],
  habitationListDetails: [],
  coursesListDetails: [],
  courseYearDetails: [],
  sectionListDetails: [],
  disabilitylist: [],
  communityList: [],
  pageflag: "",
  coursecode: "",
  EditstudentRegistaration: "",
  conformedBieditstudentDetails: [],
  recognizationcoursecode: {},
  examfeecoursecode: {},
  secondyearexamfeecoursecode: {},
  tabvalue: 0,
  failtabvalue: 0,
  faildata: {},
  secondfaildata: {},
  nominalcoursecode: {},
  nominaltabvalue: 0,
  secondnominaltabvalue: {},
  nominalEditstudentRegistaration: "",
  categorylist: [],
  coll_code: "",
  center_id: "",
  category: "",
  confirm_flag: "",
  failnominalcoursecode: {},
  // center_id: "",
  // category: "",
  // confirm_flag: "",
  dist_code: "",
  viewroom: {},
  zoneDetails: [],
  specialcategorydetails: [],
  viewmfno: "",
  reportdataenv: "",
  envview: {},
  flagstatus: "",
  envviewmfno: "",
  backFlag: false,
  editstudentadmission: {},
  backvalue: { cluster_id: "", dist_code: "", value: "1" },
  questiondata: {},

  mobile: {},
  cslogindetails: {},
  working_colleges: [],
  attdcadredata: {},

  staffcollegedetails: {},

  marksfeeteacherid: "",

  uidandyeardetails: {},
  supplyexamfeecoursecode: {},
  supplysecondyearexamfeecoursecode: {},
  AssembleyList: [],
  ParliamentList: [],
  property_id: "",
  villageid: "",
  oldassnumber: "",
  assno: "",
  dashboardflag: false,
  panchayat_secretariat_id: "",
  assessment_dataflag: "N",
  nontaxpropertydetails: {},
  celltowerdataflag: "N",
  sectariatlist: [],
  villagelist: [],
  tradeflag: "N",
  auctionflag: "N",
  villagelistverify: [],
  commonallapi: [],
  panchayat_id: "",
  revenuevillagedata: [],
  populatedetails: [],
  mappingformformikvalues: {},
  mappingformloopdata: [],
  mappingformback: false,
  habitationlist: [],
  basicinfodata: [],
  // basicinfodata: [],
  panchayatsarpanchdata: [],
  panchayatsecdata: [],
  wardmemberdata: [],
  panchayatsecretariatlist: [],
  infrastructurelist: [],
  helthcarelist: [],
  panchayatOfficePhoto: "",
  current_year: [],
  highest_year: {},
  sectotaldata: [],
  contactusdata: [],
  contactusdataroleid: null,
  childrenmouduleid: "",
  modifyflag: "N",
  modifyback: false,
  modifybackdetailsdata: false,
  rolelogindistricts: [],
  roleloginmandals: [],
  property_id_ver: 0,
  loginusername: "",
  nontaxtargetdetails: "",
  tapflag: "",
  moudule: "",
  moduletype: "",
  moduleheading: "",
  dualroles: 0,
  roledesc: "",
  role_code: "",
  modemaster: "",
  paymentcategory: "",
  currentdate: "",
  totalrecieptamount: 0,
  tapViewDcb: {},
  ass_no: "",
  reciept_num: "",
  //added code start
  distmastlist: [],
  mandalmastlist: [],
  villagemastlist: [],
  modulemastlist: [],
  submodulemastlist: [],
  innersubmodulemastlist: [],
  childinnersubmodulemastlist: [],
  rolemastlist: [],
  childinnersubmodulesrvmastlist: [],
  roleservicemapdetails: [],
  //added code end
  //ADDED CODE START
  rolemaster: [],
  //ADDED CODE END

  secretariat_id_ver: "",
  village_id_ver: "",

  outside_district: [],
  outside_mandals: [],
  outside_secretariats: [],
  outside_villages: [],
  roleservicemapping: [],

  treasurymaster: [],
  stastiticsClick: "",
  ticketStatusReportData: {},
  financialyear: [],
  propertydetails: [],
  ownerdetails: [],
  dcbdetailsdata: [],
  habitationres: [],
  typedata: "",
  adharmobile: {},
  rowdatauth: "",
  aadhaarnumauth: "",
  pansecres: [],
  writeoffOwnerData: {},
  writeoffOwnerDemandGrid: {},
  refreshtime: "",
  handleback: "",
  bankdetails: "",
  ownerview: "",
  subdetailedid: [],
  detailedid: [],
  drawlmode: [],
  itemdetails: [],
  mesarmentunit: [],
  mesarmentunitwithpricelimit: {},
  headofaccount: [],
  sectorlist: [],
  designationlist: [],
  // categorylist: [],
  vendordetails: [],
  nature_work: [],
  auctionstarget: [],
  auctionsverifypanchayat: [],
  taptarget: [],
  tapverifypanchayat: [],
  rolewisrevenuedivisions: [],
  rolewisrevenuedivisionsmandals: [],
  getdistmannmr: [],
  purposenmr: [],
  aadhaarvalidationnmr: "",
  aadhaarvalidationonnmr: "",
  nontaxesno: "",
  gettargetdetails: [],
  getenteredtarget: [],
  misaadhaarval: [],
  finyear: [],
  runningfinyear: "",
  rebatedetails: [],

  itemdescription: [],
  sectordescription: [],
  subdetailedidMiscllenaous: [],
  detailedidMiscllenaous: [],
  drawlmodeMiscllenaous: [],
  relationlist: [],
  citizenpaymenthome: "",
  citizenstatustracking: "",
  grvdetails: [],
  ruralurbanmst: "",
  locgov: {},
  selectedgrid:"district",
  selectedmptczptc:"zptc"
};

export default function CommonMastersReducer(details = initialvalues, action) {
  switch (action.type) {
    case "MEDIUM":
      return { ...details, mediumDetails: action.payload };
    case "LANGUAGE":
      return { ...details, languageDetails: action.payload };
    case "COURSE_GROUP":
      return { ...details, courseDetails: action.payload };
    case "CASTES_LIST":
      return { ...details, castesListDetails: action.payload };
    case "SUB_CASTES_LIST":
      return { ...details, subcastesListDetails: action.payload };
    case "OCCUPATION_LIST":
      return { ...details, occupationListDetails: action.payload };
    case "MOTHER_TONGUE_LIST":
      return { ...details, mothertongueListDetails: action.payload };
    case "STATE_LIST":
      return { ...details, stateListDetails: action.payload };
    case "DISTRICT_LIST":
      return { ...details, districtListDetails: action.payload };
    case "MANDAL_LIST":
      return { ...details, mandalListDetails: action.payload };
    case "PMSS_MANDAL_LIST":
      return { ...details, pmssMandalListDetails: action.payload };
    case "VILLAGE_LIST":
      return { ...details, villageListDetails: action.payload };
    case "HABITATION_LIST":
      return { ...details, habitationListDetails: action.payload };
    case "SECREATE_LIST":
      return { ...details, secreateListDetails: action.payload };
    case "COURSES_LIST":
      return { ...details, coursesListDetails: action.payload };
    case "FINYEAR":
      return { ...details, finyear: action.payload };

    case "COURSE_YEAR":
      return { ...details, courseYearDetails: action.payload };
    case "SECTIONS_LIST":
      return { ...details, sectionListDetails: action.payload };
    case "DISABILITY_LIST":
      return { ...details, disabilitylist: action.payload };
    case "COMMUNITY_LIST":
      return { ...details, communityList: action.payload };
    case "PAGE_FLAG_REDIRECTING":
      return { ...details, pageflag: action.payload };
    case "COURSE_CODE_REDIRECTING":
      return { ...details, coursecode: action.payload };
    case "EDITREGISTERLIST":
      return { ...details, EditstudentRegistaration: action.payload };
    case "CONFORMED_BIE_EDIT_STUDENT_DETAILS":
      return { ...details, conformedBieditstudentDetails: action.payload };
    case "RECOGNIZATION_COURSE_CODE":
      return { ...details, recognizationcoursecode: action.payload };
    case "EXAMFEE_COURSE_CODE":
      return { ...details, examfeecoursecode: action.payload };
    case "SECONDYEAR_EXAMFEE_COURSE_CODE":
      return { ...details, secondyearexamfeecoursecode: action.payload };
    case "TAB_VALUE":
      return { ...details, tabvalue: action.payload };
    case "OTP_DETAILS":
      return { ...details, otpdetails: action.payload };
    case "FAIL_STUDENTS_EXAMFEE":
      return { ...details, faildata: action.payload };
    case "FAIL_TAB_VALUE":
      return { ...details, failtabvalue: action.payload };
    case "SECOND_FAIL_STUDENTS_EXAMFEE":
      return { ...details, secondfaildata: action.payload };
    case "NOMINAL_COURSE_CODE":
      return { ...details, nominalcoursecode: action.payload };
    case "NOMINAL_TAB_VALUE":
      return { ...details, nominaltabvalue: action.payload };
    case "SECOND_NOMINAL_COURSE_CODE":
      return { ...details, secondnominaltabvalue: action.payload };
    case "NOMINAL_EDITREGISTERLIST":
      return { ...details, nominalEditstudentRegistaration: action.payload };
    case "categorylist":
      return { ...details, categorylist: action.payload };
    case "COLL_CODE": {
      return { ...details, coll_code: action.payload };
    }
    case "center_id": {
      return { ...details, center_id: action.payload };
    }
    case "category": {
      return { ...details, category: action.payload };
    }
    case "confirm_flag": {
      return { ...details, confirm_flag: action.payload };
    }
    case "FAIL_NOMINAL_COURSE_CODE":
      return { ...details, failnominalcoursecode: action.payload };
    case "dist_code": {
      return { ...details, dist_code: action.payload };
    }
    case "VIEW_ROOM":
      return { ...details, viewroom: action.payload };

    case "ZONES_LIST": {
      return { ...details, zoneDetails: action.payload };
    }
    case "SPECIAL_CATEGORYLIST": {
      return { ...details, specialcategorydetails: action.payload };
    }
    case "EDIT_STUDENT_ADMISSION": {
      return { ...details, editstudentadmission: action.payload };
    }

    case "REPORTDATA":
      return { ...details, reportdata: action.payload };

    case "VIEWMFNO":
      return { ...details, viewmfno: action.payload };
    case "REPORTDATAENV":
      return { ...details, reportdataenv: action.payload };
    case "ENVVIEW":
      return { ...details, envview: action.payload };
    case "FLAGSTATUS":
      return { ...details, flagstatus: action.payload };
    case "ENVVIEWMFNO":
      return { ...details, envviewmfno: action.payload };
    case "BACKVALUE": {
      return { ...details, backvalue: action.payload };
    }
    case "QUESTIONBANKDATA": {
      return { ...details, questiondata: action.payload };
    }
    case "MOBILE": {
      return { ...details, mobile: action.payload };
    }
    case "CSLOGINDETAILS":
      return { ...details, cslogindetails: action.payload };
    case "ATTDCADREDATA":
      return { ...details, attdcadredata: action.payload };

    // case "MOBILE": {
    //     return { ...details, mobile: action.payload };
    // }
    // case "CSLOGINDETAILS":
    //     return { ...details, cslogindetails: action.payload };
    // case "ATTDCADREDATA":
    //     return { ...details, attdcadredata: action.payload };

    case "WORKINGCOLLEGESSTAFF":
      return { ...details, working_colleges: action.payload };

    case "STAFFENTRYCOLLDETAILS":
      return { ...details, staffcollegedetails: action.payload };

    case "MARKSFEETEACHERID":
      return { ...details, marksfeeteacherid: action.payload };

    case "UIDANDYEAR":
      return { ...details, uidandyeardetails: action.payload };

    case "SUPPLY_EXAMFEE_COURSE_CODE":
      return { ...details, supplyexamfeecoursecode: action.payload };
    case "SUPPLY_SECONDYEAR_EXAMFEE_COURSE_CODE":
      return { ...details, supplysecondyearexamfeecoursecode: action.payload };

    case "AssembleyList":
      return { ...details, AssembleyList: action.payload };

    case "ParliamentList":
      return { ...details, ParliamentList: action.payload };

    case "PROPERTYID":
      return { ...details, property_id: action.payload };
    case "VillageID":
      return { ...details, villageid: action.payload };
    case "OLDASSNUMBER":
      return { ...details, oldassnumber: action.payload };
    case "ASSNO":
      return { ...details, assno: action.payload };

    case "DASHBOARDFLAG":
      return { ...details, dashboardflag: action.payload };
    case "PANCHAYATSECRETRAITID":
      return { ...details, panchayat_secretariat_id: action.payload };
    case "ASSESSMENTDATAFLAG":
      return { ...details, assessment_dataflag: action.payload };
    case "NONTAXPROPERTYDETAILS":
      return { ...details, nontaxpropertydetails: action.payload };
    case "CELLTOWERDATAFLAG":
      return { ...details, celltowerdataflag: action.payload };
    case "SECRETARIATLIST":
      return { ...details, sectariatlist: action.payload };
    case "VILLAGELIST":
      return { ...details, villagelist: action.payload };
    case "TRADEFLAG":
      return { ...details, tradeflag: action.payload };
    case "AUCTIONFLAG":
      return { ...details, auctionflag: action.payload };
    case "VILLAGELISTVERIFY":
      return { ...details, villagelistverify: action.payload };
    case "COMMONALLAPIS":
      return { ...details, commonallapi: action.payload };
    case "PANCHAYATID":
      return { ...details, panchayat_id: action.payload };

    case "POPULATEDDETAILS":
      return { ...details, populatedetails: action.payload };

    case "REVENUEVILLAGEDATA":
      return { ...details, revenuevillagedata: action.payload };

    case "MAPPINGFORMFORMIKVALUES":
      return { ...details, mappingformformikvalues: action.payload };
    case "MAPPINGFORMLOOPDATA":
      return { ...details, mappingformloopdata: action.payload };
    case "HABITATIONDATA":
      return { ...details, habitationList: action.payload };
    case "BASICINFODATA":
      return { ...details, basicinfodata: action.payload };
    case "PANCHAYATSARPANCHDATA":
      return { ...details, panchayatsarpanchdata: action.payload };
    case "PANCHAYATSECDATA":
      return { ...details, panchayatsecdata: action.payload };
    case "WARDMEMBERDATA":
      return { ...details, wardmemberdata: action.payload };

    case "PANCHAYATSECRETARIATDATA":
      return { ...details, panchayatsecretariatlist: action.payload };
    case "INFRASTRUCTUREFACLIST":
      return { ...details, infrastructurelist: action.payload };

    case "HEALTHCARELIST":
      return { ...details, helthcarelist: action.payload };

    case "PANCHAYATOFFICEPHOTO":
      return { ...details, panchayatOfficePhoto: action.payload };
    case "CURRENTYEAR":
      return { ...details, current_year: action.payload };

    case "HIGHESTACYEAR":
      return { ...details, highest_year: action.payload };

    case "SECTOTALDATA":
      return { ...details, sectotaldata: action.payload };

    case "CONTACTUSDATA":
      return { ...details, contactusdata: action.payload };

    case "CONTACTUSDATA_ROLE_ID":
      return { ...details, contactusdataroleid: action.payload };

    case "CHILDRENMODULEID":
      return { ...details, childrenmouduleid: action.payload };
    case "MODIFYFLAG":
      return { ...details, modifyflag: action.payload };

    case "MODIFYBACK":
      return { ...details, modifyback: action.payload };
    case "MODIFYBACKDETAILSDATA":
      return { ...details, modifybackdetailsdata: action.payload };
    case "ROLELOGINDISTRICTS":
      return { ...details, rolelogindistricts: action.payload };
    case "PROPERTYIDVER":
      return { ...details, property_id_ver: action.payload };
    case "ROLECFMSMANDALLIST":
      return { ...details, roleloginmandals: action.payload };

    case "LOGINUSERNAME":
      return { ...details, loginusername: action.payload };

    case "NONTAXTARGETDETAILS":
      return { ...details, nontaxtargetdetails: action.payload };

    case "TAPFLAG":
      return { ...details, tapflag: action.payload };
    case "MOUDULE":
      return { ...details, moudule: action.payload };
    case "MODULETYPE":
      return { ...details, moduletype: action.payload };

    case "MODULEHEADING":
      return { ...details, moduleheading: action.payload };
    case "DUALROLESDATA":
      return { ...details, dualroles: action.payload };

    case "ROLECODE":
      return { ...details, role_code: action.payload };
    case "ROLEDESC":
      return { ...details, roledesc: action.payload };
    case "MODEMASTER":
      return { ...details, modemaster: action.payload };
    case "PAYMENTCATEGOREY":
      return { ...details, paymentcategory: action.payload };

    case "CURRENTDATE":
      return { ...details, currentdate: action.payload };

    case "TOTALRECIEPTAMOUNT":
      return { ...details, totalrecieptamount: action.payload };

    case "RECINUM":
      return { ...details, reciept_num: action.payload };
    case "ASSESNUM":
      return { ...details, ass_no: action.payload };
    case "DISTRICTMASTER":
      return { ...details, distmastlist: action.payload };
    case "MANDALMASTER":
      return { ...details, mandalmastlist: action.payload };
    case "VILLAGEMASTER":
      return { ...details, villagemastlist: action.payload };
    case "MODULEMASTER":
      return { ...details, modulemastlist: action.payload };
    case "SUBMODULEMASTER":
      return { ...details, submodulemastlist: action.payload };
    case "INNERSUBMODULEMASTER":
      return { ...details, innersubmodulemastlist: action.payload };
    case "CHILDINNERSUBMODULEMASTER":
      return { ...details, childinnersubmodulemastlist: action.payload };
    case "ROLEMASTER":
      return { ...details, rolemastlist: action.payload };
    case "CHILDINNERSUBMODULEsrvMASTER":
      return { ...details, childinnersubmodulesrvmastlist: action.payload };

    case "SECIDVER1":
      return { ...details, secretariat_id_ver: action.payload };
    case "VILLAGEIDVER1":
      return { ...details, village_id_ver: action.payload };
    case "OUTSIDEDISTRICT":
      return { ...details, outside_district: action.payload };
    case "OUTSIDEMANDALS":
      return { ...details, outside_mandals: action.payload };
    case "OUTSIDESECRETARIAT":
      return { ...details, outside_secretariats: action.payload };
    case "OUTSIDEVILLAGES":
      return { ...details, outside_villages: action.payload };

    case "ROLEMASTER1":
      return { ...details, rolemaster: action.payload };
    case "ROLESERVICEMAP":
      return { ...details, roleservicemapdetails: action.payload };

    case "TRESURYMASTER":
      return { ...details, treasurymaster: action.payload };

    case "STASTITICS_CLICK":
      return { ...details, stastiticsClick: action.payload };

    case "TICKET_STATUS_REPORTDATA":
      return { ...details, ticketStatusReportData: action.payload };
    case "FINANCIALYEAR":
      return { ...details, financialyear: action.payload };
    case "PROPERTYDETAILS":
      return { ...details, propertydetails: action.payload };
    case "OWNERDETAILS":
      return { ...details, ownerdetails: action.payload };
    case "DCBDETAILSDATA":
      return { ...details, dcbdetailsdata: action.payload };
    case "HABITATIONRES":
      return { ...details, habitationres: action.payload };
    case "TYPEDATA":
      return { ...details, typedata: action.payload };
    case "ADHARMOBILE":
      return { ...details, adharmobile: action.payload };
    case "ROWDATAAUTH":
      return { ...details, rowdatauth: action.payload };
    case "AADHAARNUMAUTH":
      return { ...details, aadhaarnumauth: action.payload };
    case "PANSECRES":
      return { ...details, pansecres: action.payload };
    case "WRITEOFFOWNERDATA":
      return { ...details, writeoffOwnerData: action.payload };
    case "WRITEOFFOWNERDEMANDGRID":
      return { ...details, writeoffOwnerDemandGrid: action.payload };
    case "REFRESHTIMEVIEWS":
      return { ...details, refreshtime: action.payload };
    case "HANDLEBACK":
      return { ...details, handleback: action.payload };
    case "BANKDETAILS":
      return { ...details, bankdetails: action.payload };
    case "OWNERVIEW":
      return { ...details, ownerview: action.payload };
    case "SUBDETAILEDID":
      return { ...details, subdetailedid: action.payload };
    case "DETAILEDID":
      return { ...details, detailedid: action.payload };
    case "DRAWLMODEMAST":
      return { ...details, drawlmode: action.payload };
    case "ITEMDETAILS":
      return { ...details, itemdetails: action.payload };
    case "MEASUREMENTUNIT":
      return { ...details, mesarmentunit: action.payload };
    case "MEASUREMENTUNITWITHPRICELIMIT":
      return {
        ...details,
        mesarmentunitwithpricelimit: {
          ...details.mesarmentunitwithpricelimit,
          [action.payload.itemDetailsId]: action.payload.data,
        },
      };
    case "HEADOFACCOUNT":
      return { ...details, headofaccount: action.payload };
    case "SECTORLIST":
      return { ...details, sectorlist: action.payload };
    case "DESIGNATIONLIST":
      return { ...details, designationlist: action.payload };
    case "CATEGORYLIST":
      return { ...details, categorylist: action.payload };
    case "NATURELIST":
      return { ...details, nature_work: action.payload };
    case "VENDERDETAILS":
      return { ...details, vendordetails: action.payload };

    case "AUCTIONSTARGET":
      return { ...details, auctionstarget: action.payload };
    case "AUCTIONSVERIFYPANCHAYATDETAILS":
      return { ...details, auctionsverifypanchayat: action.payload };
    case "TAPTARGET":
      return { ...details, taptarget: action.payload };
    case "TAPVERIFYPANCHAYATDETAILS":
      return { ...details, tapverifypanchayat: action.payload };

    case "ROLEREVENUEDIVISIONS":
      return { ...details, rolewisrevenuedivisions: action.payload };

    case "ROLEREVENUEDIVISIONSMANDAL":
      return { ...details, rolewisrevenuedivisionsmandals: action.payload };

    case "GETDISMANNMR":
      return { ...details, getdistmannmr: action.payload };
    case "PURPOSENMR":
      return { ...details, purposenmr: action.payload };

    case "AADHAARVALIDATIONDATANMR":
      return { ...details, aadhaarvalidationnmr: action.payload };

    case "AADHAARVALIDATIONDATANONNMR":
      return { ...details, aadhaarvalidationonnmr: action.payload };

    case "NONTAXESNO":
      return { ...details, nontaxesno: action.payload };

    case "GETTARGETDETAILS":
      return { ...details, gettargetdetails: action.payload };

    case "GETENTEREDTARGET":
      return { ...details, getenteredtarget: action.payload };
    case "MISAADHAARVAL":
      return { ...details, misaadhaarval: action.payload };
    case "RUNNINGFINYEAR":
      return { ...details, runningfinyear: action.payload };
    case "REBATEDETAILS":
      return { ...details, rebatedetails: action.payload };

    case "ITEMDESCRIPTION":
      return { ...details, itemdescription: action.payload };

    case "SECTORDESCRIPTION":
      return { ...details, sectordescription: action.payload };

    case "SUBDETAILEDIDMISCLLENAOUS":
      return { ...details, subdetailedidMiscllenaous: action.payload };

    case "DETAILEDIDMISCLLENAOUS":
      return { ...details, detailedidMiscllenaous: action.payload };

    case "DRAWLMODEMISCLLENAOUS":
      return { ...details, drawlmodeMiscllenaous: action.payload };

    case "RELATIONLIST":
      return { ...details, relationlist: action.payload };
    case "CITIZENPAYMENTHOME":
      return { ...details, citizenpaymenthome: action.payload };
    case "CITIZENSTATUSTRACKING":
      return { ...details, citizenstatustracking: action.payload };
    case "GRVENCEDETAILS":
      return { ...details, grvdetails: action.payload };
    case "LOCGOV":
      return { ...details, locgov: action.payload };
    case "RURALURBANMST":
      return { ...details, ruralurbanmst: action.payload };
       case "SELECTEDGRID":
      return { ...details, selectedgrid: action.payload };
      case "SELECTEDMPTCZPTC":
      return { ...details, selectedmptczptc: action.payload };
    default:
      return details;
  }
}
